import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomepageComponent } from './homepage/homepage.component';
import {SharedModule} from '../../shared/shared.module';
import {LayoutModule} from '../../layout/layout.module';
import { MobxTicTacComponent } from './mobx-tic-tac/mobx-tic-tac.component';
import {TicTacToeModule} from './mobx-tic-tac/tic-tac-toe/tic-tac-toe.module';

@NgModule({
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule,
    LayoutModule,
    TicTacToeModule
  ],
  declarations: [HomepageComponent, MobxTicTacComponent]
})
export class HomeModule { }



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/home.module.ts